// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"d598b731","293":"7ae52889","516":"b530ca14","917":"c6609590","946":"af83a3ce"}[chunkId] + ".chunk.js";
};